import React from 'react';

const AddAwardForm = ({ awardBodies, onAdd, onCancel }) => {
  const [selectedBody, setSelectedBody] = React.useState('');
  const [selectedLevel, setSelectedLevel] = React.useState('');
  const [year, setYear] = React.useState(new Date().getFullYear());

  const bodyOptions = Object.entries(awardBodies);
  const levelOptions = selectedBody ? awardBodies[selectedBody]?.levels || [] : [];

  return (
    <div className="mt-4 p-4 bg-[#F5F1EC] rounded-lg space-y-3" data-testid="add-award-form">
      <div className="grid grid-cols-3 gap-2">
        <select
          value={selectedBody}
          onChange={(e) => { setSelectedBody(e.target.value); setSelectedLevel(''); }}
          className="text-sm border border-[#E8DCD0] rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-[#A94438]/20"
          data-testid="award-body-select"
        >
          <option value="">Award body...</option>
          {bodyOptions.map(([key, val]) => (
            <option key={key} value={key}>{val.name}</option>
          ))}
        </select>
        <select
          value={selectedLevel}
          onChange={(e) => setSelectedLevel(e.target.value)}
          className="text-sm border border-[#E8DCD0] rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-[#A94438]/20"
          disabled={!selectedBody}
          data-testid="award-level-select"
        >
          <option value="">Level...</option>
          {levelOptions.map((level) => (
            <option key={level} value={level}>{level}</option>
          ))}
        </select>
        <input
          type="number"
          value={year}
          onChange={(e) => setYear(parseInt(e.target.value))}
          min={2000}
          max={2030}
          className="text-sm border border-[#E8DCD0] rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-[#A94438]/20"
          data-testid="award-year-input"
        />
      </div>
      <div className="flex gap-2 justify-end">
        <button onClick={onCancel} className="text-sm text-[#7A7873] hover:text-[#1A1918] px-3 py-1.5">Cancel</button>
        <button
          onClick={() => selectedBody && selectedLevel && onAdd(selectedBody, selectedLevel, year)}
          disabled={!selectedBody || !selectedLevel}
          className="text-sm bg-[#4B5945] text-white px-4 py-1.5 rounded-lg hover:bg-[#3d4a38] disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid="confirm-add-award-btn"
        >
          Add Award
        </button>
      </div>
    </div>
  );
};

export default AddAwardForm;
